import '@theme/gsap'
import { mediaQueryLarge } from '@theme/use-device-detection'

const SELECTOR = '[data-parallax]'
const MEDIA_CONDITIONS = {
  isDesktop: mediaQueryLarge.media,
  allowsMotion: '(prefers-reduced-motion: no-preference)'
}

 




















 
const activeParallax = new Map()





function parsePair(value) {
  if (!value) return null
  const parts = value.split(',').map((part) => Number.parseFloat(part.trim()))
  if (parts.length !== 2 || parts.some(Number.isNaN)) return null
  return parts
}





function parseY(value) {
  if (!value) return null

  if (value.endsWith('%')) {
    const percentage = Number.parseFloat(value)
    if (Number.isNaN(percentage)) return null
    return { from: '0%', to: `${percentage}%` }
  }

  const pixels = Number.parseFloat(value)
  if (Number.isNaN(pixels)) return null
  const halfDistance = pixels / 2
  return { from: -halfDistance, to: halfDistance }
}






function addYVars(fromVars, toVars, value) {
  const range = parseY(value)
  if (!range) return

  fromVars.y = range.from
  toVars.y = range.to
}







function addNumericRange(fromVars, toVars, value, property) {
  const range = parsePair(value)
  if (!range) return

  const [start, end] = range
  fromVars[property] = start
  toVars[property] = end
}






function addNumericVisualRanges(element, fromVars, toVars) {
  addNumericRange(
    fromVars,
    toVars,
    element.dataset.parallaxScale || null,
    'scale'
  )
}





function buildTweenVars(element) {
  const fromVars = {}
  const toVars = {}

  addYVars(fromVars, toVars, element.dataset.parallaxY || null)
  addNumericVisualRanges(element, fromVars, toVars)

  if (Object.keys(fromVars).length === 0) return null
  toVars.ease = 'none'
  return { fromVars, toVars }
}





function clampPosition(position) {
  const normalizedPosition = position.trim()
  if (normalizedPosition.startsWith('clamp(')) return normalizedPosition
  return `clamp(${normalizedPosition})`
}





function buildTriggerConfig(element) {
  const triggerSelector = element.dataset.parallaxTrigger || null
  const trigger = triggerSelector
    ? element.closest(triggerSelector) || element
    : element

  return {
    trigger,
    start: clampPosition(element.dataset.parallaxStart || 'top bottom'),
    end: clampPosition(element.dataset.parallaxEnd || 'bottom top'),
    scrub: true
  }
}






function buildConfig(element, conditions) {
  if (!(conditions.isDesktop && conditions.allowsMotion)) return null

  const tweenVars = buildTweenVars(element)
  if (!tweenVars) return null

  return { ...tweenVars, triggerConfig: buildTriggerConfig(element) }
}






function createParallaxTween(element, conditions, gsap) {
  const config = buildConfig(element, conditions)
  if (!config) return

  gsap.fromTo(element, config.fromVars, {
    ...config.toVars,
    scrollTrigger: config.triggerConfig
  })
}





function registerParallax(element, gsap) {
  const media = gsap.matchMedia()
  media.add(MEDIA_CONDITIONS, (context) => {
    if (!context.conditions) return
    createParallaxTween(element, context.conditions, gsap)
  })
  activeParallax.set(element, media)
}





function getParallaxElements(scope) {
  const elements = Array.from(scope.querySelectorAll(SELECTOR))
  if (scope instanceof HTMLElement && scope.matches(SELECTOR)) {
    elements.unshift(scope)
  }
  return elements.filter((element) => element instanceof HTMLElement)
}




function getGsapRuntime() {
  const gsap = window.gsap
  if (!(gsap && window.ScrollTrigger && gsap.matchMedia)) return null
  return gsap
}




function init(scope = document) {
  if (!mediaQueryLarge.matches) return

  const gsap = getGsapRuntime()
  if (!gsap) return

  for (const element of getParallaxElements(scope)) {
    if (activeParallax.has(element)) continue
    registerParallax(element, gsap)
  }
}




function destroy(element) {
  const media = activeParallax.get(element)
  if (!media) return

  media.revert()
  activeParallax.delete(element)
}

 
function onSectionLoad(event) {
  if (event.target instanceof HTMLElement) init(event.target)
}

 
function onSectionUnload(event) {
  if (!(event.target instanceof HTMLElement)) return
  for (const element of getParallaxElements(event.target)) destroy(element)
}





function onBreakpointChange(event) {
  if (event.matches) {
    init()
    return
  }
  for (const element of [...activeParallax.keys()]) destroy(element)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(), { once: true })
} else {
  init()
}

document.addEventListener('shopify:section:load', onSectionLoad)
document.addEventListener('shopify:section:unload', onSectionUnload)
mediaQueryLarge.addEventListener('change', onBreakpointChange)
